<script setup>
import {__} from "../../../../assets/javascripts/library";
import PdfViewer from "../../../../assets/components/PdfViewer.vue";
import DistanceAllowance from "../DistanceAllowance.vue";

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(["reject"])
</script>

<template>
<span id="invoice_details_header">
    <table>
      <tr>
        <td>{{__('Name', 'mareike')}}:</td>
        <td>{{props.data.name}}</td>

        <td style="width: 250px;">{{__('Cost unit', 'mareike')}}</td>

        <td>{{props.data.cost_unit_name}}</td>
        <td rowspan="4" style="vertical-align: top;">
          <button
              v-if="props.data.status === 'NEW'"
              @click="emit('reject')"
              class="button mareike-button mareike-deny-button"
          >
            {{__('Reject invoice', 'mareike') }}
          </button>
        </td>
      </tr>

      <!-- Rest der Tabelle bleibt unverändert -->
      <tr>
        <td>{{__('E-Mail', 'mareike')}}:</td>
        <td>{{props.data.email}}</td>
        <td>{{__('Invoice number', 'mareike')}}:
        </td>

        <td>{{props.data.invoice_number}}</td>
      </tr>
      <tr>
        <td>{{__('Account owner', 'mareike')}}:</td>
        <td>{{props.data.account_owner}}</td>
        <td>
          {{__('Invoice type', 'mareike')}}:
        </td>
        <td>{{props.data.type}}<label v-if="props.data.type === __('Other', 'mareike')"> ({{ props.data.type_other}})</label></td>
      </tr>
      <tr>
        <td>{{__('Account IBAN', 'mareike')}}:</td>
        <td>{{props.data.account_iban}}</td>
        <td>{{__('Total amount', 'mareike')}}:
        </td>
        <td><strong>{{props.data.amount}}</strong></td>
      </tr>
      <tr>
        <td>{{__('Invoice status', 'mareike')}}:</td>
        <td>{{props.data.status}}</td>
        <td>{{__('Notices', 'mareike')}}:</td>
        <td>
          <span v-if="props.data.status === 'DENIED' || props.data.status === 'DENIED_EXPORTED'">
            {{props.data.denied_reason}}
          </span>
          <span v-else>{{props.data.comment}}</span>
        </td>
      </tr>
    </table>
  </span>
</template>

<style scoped>

</style>